import { useMutation, useQuery } from "@apollo/client";
import {
  MUTATION_ADD_ATHLETE_TO_GROUP,
  MUTATION_REMOVE_ATHLETE_FROM_GROUP,
  QUERY_GROUP_ATHLETE,
} from "./GroupUtil";

export default function GroupAddAthleteButton({
  group_id,
  athlete_id,
  className,
  refetch,
}) {
  const {
    data,
    loading,
    refetch: refetchGroupAthleteMembership,
  } = useQuery(QUERY_GROUP_ATHLETE, {
    variables: { group_id: group_id, athlete_id: athlete_id },
  });
  const [addAthleteToGroup, { loading: addAthleteToGroupLoading }] =
    useMutation(MUTATION_ADD_ATHLETE_TO_GROUP);

  const [removeAthleteFromGroup, { loading: removeAthleteFromGroupLoading }] =
    useMutation(MUTATION_REMOVE_ATHLETE_FROM_GROUP);

  if (loading) return null;

  if (data && data.group_athlete) {
    return (
      <button
        disabled={addAthleteToGroupLoading || removeAthleteFromGroupLoading}
        className={`btn btn-primary ${className}`}
        onClick={async () => {
          await removeAthleteFromGroup({
            variables: { group_id: group_id, athlete_id: athlete_id },
          });
          refetchGroupAthleteMembership();
          refetch();
        }}
      >
        Retirer du groupe
      </button>
    );
  } else {
    return (
      <button
        disabled={addAthleteToGroupLoading || removeAthleteFromGroupLoading}
        className={`btn btn-primary ${className}`}
        onClick={async () => {
          let result = await addAthleteToGroup({
            variables: { group_id: group_id, athlete_id: athlete_id },
          });
          if (result && result.data && result.data.add_athlete_to_group) {
            refetchGroupAthleteMembership();
            refetch();
          }
        }}
      >
        Ajouter au groupe
      </button>
    );
  }
}
